// extracted by mini-css-extract-plugin
export default {"link":"TextLink_link__+gQBX","icon":"TextLink_icon__AvzcA"};